import { EventtypeService } from 'src/app/services/eventtype.service';
import { environment } from 'src/environments/environment';
import { CompanyService } from './../../services/company.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Storage } from '@ionic/storage-angular';
import { Subject, throwError } from 'rxjs';
import { catchError, takeUntil, takeWhile } from 'rxjs/operators';
import { UserData } from 'src/app/providers/user-data';
import { AuthService } from 'src/app/services/auth.service';
import { SettingsService } from 'src/app/services/settings.service';
import { Company } from 'src/app/interfaces/company';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: 'login.page.html',
  styleUrls: ['./login.page.scss']
})
export class LoginPage implements OnInit, OnDestroy {
  public loginFormGroup = this.formBuilder.group({
    email: ['', Validators.email]
  });

  email = '';
  submitted = false;
  showMessage = false;
  eventtypeName: string;

  public clientVersion: string;

  message: {
    status: boolean;
    text: string;
  };

  loading = false;
  count: number;
  private companyId: string;

  onDestroy = new Subject();
  inIframe: boolean = true;
  company: Company;
  colors: string[];

  constructor(
    public userData: UserData,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    public settingsService: SettingsService,
    private formBuilder: FormBuilder,
    private storage: Storage,
    private companyService: CompanyService,
    private eventtypeService: EventtypeService
  ) { }

  async ngOnInit() {
    if (window.location !== window.parent.location) {
      this.inIframe = true
    } else {
      this.inIframe = false
    }
    var params = location.href.split('?')[1].split('&');
    this.companyId = params[0].split("=")[1];
    this.eventtypeService.getEventtypeById(params[1].split("=")[1]).subscribe(async res => {
      await this.storage.set(environment.storage.serviceIFrame, res)
      this.eventtypeName = res["name"]

    }, err => {
      console.log("ERROR: ", err)
    })

    this.companyService.getCompanyById(this.companyId).subscribe(async res => {
      this.company = res;
      await this.storage.set(environment.storage.company, res);
      if (this.company) {
        this.colors = [this.company.primary_color, this.company.secondary_color]
        let root = document.documentElement;
        if (this.colors[0] != undefined) {
          root.style.setProperty('--ion-color-primary', this.colors[0]);
        } else {
          root.style.setProperty('--ion-color-primary', 'grey');
        }
        if (this.colors[1] != undefined) {
          root.style.setProperty('--ion-color-secondary', this.colors[1]);
        } else {
          root.style.setProperty('--ion-color-secondary', 'goldenrod');
        }
      }
    })

    this.clientVersion = this.settingsService.getClientVersion();

    console.log('Client version: ' + this.clientVersion);

    this.settingsService
      .isServerAvailable()
      .pipe(
        catchError(err => {
          if (err.name === 'TimeoutError') {
            this.message = {
              status: false,
              text: 'settings.server_not_reachable'
            };
          }
          return throwError(err);
        })
      )
      .subscribe(_ => {
        this.authService.checkToken();
        console.log('Checking Token in ngOnInit');
      });
  }



  onCountChange(event) {
    this.count = event;
  }

  onEmailChange(event) {
    this.email = event.toLowerCase();
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
  }

  onLogin() {
    this.count = 180;
    this.loading = true;
    this.message = undefined;
    this.authService
      .loginWithEmailCustomer(this.loginFormGroup.get('email').value.toLowerCase())  // event
      .pipe(
        takeWhile(({ result }) => {
          if (result === true) {
            console.log('Login successful!');
            this.count = 0;
            this.router.navigate([this.activatedRoute.snapshot.queryParams.id || 'error', 'wizard-event']);  //TODO: what to do when ID is not supplied?
          }
          return result === false && this.count > 0;
        }),
        takeUntil(this.onDestroy)
      )
      .subscribe(
        ({ result }) => {
          this.loading = false;
          this.message = {
            status: true,
            text: 'Bitte überprüfen sie ihr Email-Postfach'
          };
        },
        error => {
          this.loading = false;
          this.message = {
            status: false,
            text: error.error.message
          };
        },
        () => {
          this.message = {
            status: true,
            // text: 'login.timeout'
            text: 'Timeout erreicht. Bitte versuchen Sie erneut, sich anzumelden'
          };
          setTimeout(() => {
            this.message = {
              status: true,
              text: undefined
            };
          }, 5000);
        });
    this.showMessage = true;
  }
}
